import Numeral from 'numeral';
import Cache from 'root/cache';
import Constants from 'root/constants';
import Util from 'root/module/util';
import View from 'view/base';

export default View.extend({
    initialize: function(options) {
        this.data = options.data;
    },

    render: function() {
        var unassigned_total = this.data.feedback_users[0] ? this.data.feedback_users[0].total : 0;
        var project_key = Cache.getDefaultProject().get('project_key');

        var content =
        '<h3 class="widget-title"><b>Assignee</b></h3>' +
        '<div class="box box-nopadding">' +
            '<div class="user-row">' +
                '<div class="user-32">?</div>' +
                '<div class="detail">' +
                    '<div>' +
                        '<span class="name">Unassigned</span>' +
                    '</div>' +
                '</div>' +
                '<div class="stats-container">' +
                    '<a class="stats no-underline badge-primary-invert font-weight-medium navigation" href="/' + project_key + '/feedback/?assignee=0">' + Numeral(unassigned_total).format('0,0') + '</a>' +
                '</div>' +
            '</div>';

        Cache.app.getUsersByProject(Cache.default_project_id, [Constants.ADMIN, Constants.ASSIGNEE]).forEach((user) => {
            var total = this.data.feedback_users[user.id] ? this.data.feedback_users[user.id].total : 0;

            content +=
            '<div class="user-row">' +
                '<div class="flex-c"><img class="user-32" src="' + Util.htmlEntities(user.getAvatar(32)) + '"></div>' +
                '<div class="detail">' +
                    '<div>' +
                        '<span class="name">' + user.escape('name') + '</span>' +
                        '<span class="last-login">Last login: ' + (Util.moment(user.get('last_login')) || 'never') + '</span>' +
                    '</div>' +
                '</div>' +
                '<div class="stats-container">' +
                    '<a class="stats no-underline badge-primary-invert font-weight-medium navigation" href="/' + project_key + '/feedback/?assignee=' + user.id + '">' + Numeral(total).format('0,0') + '</a>' +
                '</div>' +
            '</div>';
        });

        content += '</div>';

        this.$el.html(content);

        return this;
    }
});